import { render, staticRenderFns } from "./CopyLesson.vue?vue&type=template&id=14c63a6c&scoped=true&"
import script from "./CopyLesson.vue?vue&type=script&lang=ts&"
export * from "./CopyLesson.vue?vue&type=script&lang=ts&"
import style0 from "./CopyLesson.vue?vue&type=style&index=0&id=14c63a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c63a6c",
  null
  
)

export default component.exports